import { useEffect, type EffectCallback } from 'react';

function useEffectOnce(effect: EffectCallback) {
  useEffect(effect, [effect]);
}

export default useEffectOnce;
